export enum PredefinedSegmentFolderIdentifier {
  NEW_APPLICANTS = 'new_applicants',
  PROGRAMS = 'programs',
  TAGS = 'tags',
  HIGHLIGHTS = 'highlights',
}
